import Vue from "vue";
import VueRouter from "vue-router";

import Router from "./router";

Vue.use(VueRouter);

const router = new VueRouter(Router);

export default router;
